import { useQuery } from "@tanstack/react-query";
import { fetcher } from "@/shared/api";
import type { BusinessTypesResponse } from "../store/useOnboardingStore";

const businessQueryKeys = {
  all: ["business"] as const,
  business: () => [...businessQueryKeys.all, "business"] as const,
};

export const useBusinessTypesQuery = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: businessQueryKeys.business(),
    queryFn: () => fetcher<BusinessTypesResponse>("/onboarding-v2/business-types"),
    enabled: options?.enabled ?? true,
  });
};
